<template>
  <div class="soon-wrapper">
    Скоро здесь будет дневник питания
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>

</style>